import type { ReportRow } from '../models/report.types'

function finiteNumber(value: unknown): number | null {
  return typeof value === 'number' && Number.isFinite(value) ? value : null
}

/** Ratio delta from the controller's current and `prev_<field>` values. */
export function calcChange(row: ReportRow, metricField: string): number | null {
  if (!metricField) return null
  const current = finiteNumber(row[metricField])
  const previous = finiteNumber(row[`prev_${metricField}`])
  if (current === null || previous === null || previous === 0) return null
  const change = (current - previous) / previous
  return Number.isFinite(change) ? change : null
}
